import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import {
  type FavoriteDriverRequest,
  toggleFavoriteDriverFn,
} from './toggle-favorite-driver-fn';

export const useToggleFavoriteDriver = (
  opts?: UseMutationOptions<
    NonNullable<unknown>,
    DefaultQueryError,
    FavoriteDriverRequest
  >
) => {
  return useMutation<
    NonNullable<unknown>,
    DefaultQueryError,
    FavoriteDriverRequest
  >({
    mutationFn: toggleFavoriteDriverFn,
    ...opts,
  });
};
